import { createContext } from "react";

const AccessTokenContext = createContext();



export { AccessTokenContext };